// extracted by mini-css-extract-plugin
export var fadeInOut = "_44-3";
export var icon = "_44-4";
export var savedIndicator = "_44-2";
export var savingIndicator = "_44-0";
export var spin = "_44-1";